import React from 'react';

import { Div } from 'nexcomponent-ui';

import {
  productCategorySearchBreadCrumb,
} from '../../../../Enum/Breadcrumb/ProductCategoryBreadcrumb';
import {
  searchProductCategoryColumn,
} from '../../../../Enum/Column/SearchProductCategoryColumn';
import { MAPPING_CODE } from '../../../../Enum/MappingCode/MappingCode';
import {
  ROUTER_CONSTANT,
} from '../../../../Enum/RouterConstant/RouterConstant';
import {
  fetchDataProductCategorySearchList,
} from '../../../../Fetch/FetchData/ProductCategoryData';
import FieldProductCategorySearchForm
  from '../../../Organisms/Form/SearchForm/FieldProductCategorySearchForm/FieldProductCategorySearchForm';
import SearchForm
  from '../../../Organisms/Form/SearchForm/SearchForm/SearchForm';
import HeaderPage from '../../../Organisms/Header/HeaderPage/HeaderPage';

function ProductCategorySearchPage(props) {
  return (
    <Div>
      <HeaderPage
        title={props.t("PRODUCT_CATEGORY:SEARCH.TITLE")}
        listBreadcrumb={productCategorySearchBreadCrumb(props.t)}
        defaultBreadcrumb={props.t("PRODUCT_CATEGORY:SEARCH.TITLE")}
        toTitlePage={ROUTER_CONSTANT.PRODUCT_CATEGORY.MAPPING}
      />
      <SearchForm
        title="PRODUCT_CATEGORY:SEARCH.TITLE"
        field={<FieldProductCategorySearchForm t={props.t} dispatch={props.dispatch} />}
        t={props.t}
        dispatch={props.dispatch}
        mappingCode={MAPPING_CODE.PRODUCT_CATEGORY}
        navigate={props.navigate}
        advance={false}
        columnDefault={searchProductCategoryColumn(props.t)}
        backNavigate={ROUTER_CONSTANT.PRODUCT_CATEGORY.MAPPING}
        searchFunc={(currentPage, rowLimit,filter, column,dispatch) =>
          fetchDataProductCategorySearchList(
            props.validToken(),
            currentPage,
            rowLimit,
            filter,
            column,
            dispatch,
            props.notify
          )
        }
      />
    </Div>
  );
}

export default ProductCategorySearchPage;
